// extracted by mini-css-extract-plugin
export default {"tableloader":"TableLoader_tableloader__xaixT","spin":"TableLoader_spin__KLmAQ"};